module.exports = __webpack_public_path__ + "static/media/Marketing_Efficiency_of_Major_Spices.d9ed9c25.pdf";